// extracted by mini-css-extract-plugin
module.exports = {"value":"TInfoText_value__7PxD6"};